import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background-color: #1e88e5;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 28rem;
  padding: 2.5rem 2rem 3rem;
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);

  > svg {
    margin-bottom: 2rem;
  }
`;

export const ErrorMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.75rem;
  padding: 1rem 0 0;
  width: 100%;

  .error-icon {
    line-height: 0;
  }

  h2 {
    font-family: 'RedHatDisplay-Bold';
    font-size: 1.2rem;
    color: #333;
    margin: 0;
  }

  p {
    font-family: 'RedHatDisplay-Regular';
    font-size: 0.88rem;
    color: #666;
    line-height: 1.5;
    margin: 0;
  }

  .actions {
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
    width: 100%;
    margin-top: 1rem;
  }

  button,
  a {
    display: block;
    width: 100%;
    text-align: center;
    text-decoration: none;
    background: none;
    border: 2px solid #ff9800;
    border-radius: 0.5rem;
    padding: 0.6rem 1.5rem;
    font-family: 'RedHatDisplay-Bold';
    font-size: 0.9rem;
    color: #ff9800;
    cursor: pointer;
    transition:
      background-color 0.2s ease,
      color 0.2s ease;

    &:hover {
      background-color: #ff9800;
      color: #fff;
    }

    &:focus-visible {
      outline: 2px solid #ff9800;
      outline-offset: 2px;
    }
  }

  button.primary {
    background-color: #ff9800;
    color: #fff;

    &:hover {
      filter: brightness(0.95);
    }
  }
`;
